import { X, Plus, Minus } from "lucide-react";
import { Link } from "react-router-dom";
import { useCart } from "../context/CartContext";

export default function CartDrawer() {
  const { items, open, setOpen, updateQty, removeItem, subtotal } = useCart();

  return (
    <>
      <div
        className={`fixed inset-0 z-50 bg-black/30 backdrop-blur-sm transition-opacity ${
          open ? "opacity-100 pointer-events-auto" : "opacity-0 pointer-events-none"
        }`}
        onClick={() => setOpen(false)}
      />
      <aside
        className={`fixed top-0 right-0 h-full w-full sm:w-[440px] bg-white z-50 shadow-2xl transition-transform duration-500 ${
          open ? "translate-x-0" : "translate-x-full"
        }`}
        data-testid="cart-drawer"
      >
        <div className="flex flex-col h-full">
          <div className="flex items-center justify-between px-8 py-6 border-b border-[#e5e5e5]">
            <div className="font-display text-lg font-bold tracking-tight">Your Bag</div>
            <button
              onClick={() => setOpen(false)}
              className="hover:opacity-60"
              data-testid="cart-close"
              aria-label="Close cart"
            >
              <X size={20} />
            </button>
          </div>

          <div className="flex-1 overflow-y-auto px-8 py-6">
            {items.length === 0 ? (
              <div className="text-center text-[#666] mt-20 text-sm" data-testid="cart-empty">
                Your bag is empty.
              </div>
            ) : (
              <ul className="flex flex-col gap-6">
                {items.map((it) => (
                  <li
                    key={`${it.product_id}-${it.size}-${it.color || ""}`}
                    className="flex gap-4"
                    data-testid={`cart-item-${it.product_id}`}
                  >
                    <div className="w-24 h-28 bg-[#f5f5f5] flex-shrink-0 overflow-hidden">
                      <img src={it.image_url} alt={it.name} className="w-full h-full object-cover" />
                    </div>
                    <div className="flex-1 flex flex-col justify-between">
                      <div>
                        <div className="text-sm font-medium">{it.name}</div>
                        <div className="text-xs text-[#666] mt-1">
                          Size {it.size}{it.color ? ` · ${it.color}` : ""}
                        </div>
                        <div className="text-sm mt-1">₹{it.price.toFixed(2)}</div>
                      </div>
                      <div className="flex items-center justify-between">
                        <div className="flex items-center border border-[#e5e5e5]">
                          <button
                            className="px-2 py-1 hover:bg-[#f5f5f5]"
                            onClick={() => updateQty(it.product_id, it.size, it.color, it.quantity - 1)}
                            data-testid={`qty-dec-${it.product_id}`}
                          >
                            <Minus size={12} />
                          </button>
                          <span className="px-3 text-sm">{it.quantity}</span>
                          <button
                            className="px-2 py-1 hover:bg-[#f5f5f5]"
                            onClick={() => updateQty(it.product_id, it.size, it.color, it.quantity + 1)}
                            data-testid={`qty-inc-${it.product_id}`}
                          >
                            <Plus size={12} />
                          </button>
                        </div>
                        <button
                          onClick={() => removeItem(it.product_id, it.size, it.color)}
                          className="text-xs uppercase tracking-widest text-[#666] hover:text-[#111]"
                          data-testid={`cart-remove-${it.product_id}`}
                        >
                          Remove
                        </button>
                      </div>
                    </div>
                  </li>
                ))}
              </ul>
            )}
          </div>

          {items.length > 0 && (
            <div className="px-8 py-6 border-t border-[#e5e5e5]">
              <div className="flex items-center justify-between mb-6">
                <span className="text-sm uppercase tracking-widest text-[#666]">Subtotal</span>
                <span className="font-display text-lg font-bold" data-testid="cart-subtotal">
                  ₹{subtotal.toFixed(2)}
                </span>
              </div>
              <Link
                to="/checkout"
                onClick={() => setOpen(false)}
                className="block w-full text-center bg-[#111] text-white px-8 py-4 text-sm font-medium hover:bg-[#333] transition-colors"
                data-testid="checkout-button"
              >
                Checkout
              </Link>
              <p className="text-xs text-[#666] text-center mt-4">
                Shipping & taxes calculated at next step
              </p>
            </div>
          )}
        </div>
      </aside>
    </>
  );
}
